import { executeGET } from "../../../Utils/ServiceMethods";
import { toast } from "react-toastify";
import { SessionTimeout } from "../../../Utils/ErrorMessages";
import { removeUserCredentials } from "../../../Utils/LocalStorage";

export const GetMarketplaceBusinessTermsConditionApi = async (cb) => {
  try {
    const response = await executeGET("/marketplace-business-terms-condition");

    return response?.data || [];
  } catch (error) {
    if (error?.response?.data?.message === "Token is invalid!") {
      toast.dismiss();
      toast.clearWaitingQueue();

       toast.error(SessionTimeout, {
         position: "top-center",
         width: "500px",
         autoClose: 6000,
         hideProgressBar: true,
         closeOnClick: true,
         pauseOnHover: true,
         draggable: true,
         progress: undefined,
         theme: "dark",
       });

      removeUserCredentials();

      if (cb) cb();
    }

    return false;
  }
};
